module.exports = __webpack_public_path__ + "static/media/sunflower.aa0a9005.jpg";